import script from "./sidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./sidebar.vue?vue&type=script&setup=true&lang=js"

import "./sidebar.vue?vue&type=style&index=0&id=41d9b948&scoped=true&lang=css"

import exportComponent from "D:\\Assets\\pythonScripts\\bushmanFrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41d9b948"]])

export default __exports__